import { useEffect, useState } from "react";

export function isStandalone() {
  return (
    window.matchMedia?.("(display-mode: standalone)").matches ||
    window.navigator.standalone === true ||
    document.referrer.includes("android-app://")
  );
}

export function isIOS() {
  const ua = window.navigator.userAgent;
  return /iphone|ipad|ipod/i.test(ua) && !window.MSStream;
}

export function isAndroid() {
  return /android/i.test(window.navigator.userAgent);
}

export function usePWA() {
  const [deferred, setDeferred] = useState(window.__gfDeferredPrompt || null);
  const [installed, setInstalled] = useState(isStandalone());

  useEffect(() => {
    const onBIP = (e) => { e.preventDefault(); window.__gfDeferredPrompt = e; setDeferred(e); };
    const onInstalled = () => { setInstalled(true); window.__gfDeferredPrompt = null; setDeferred(null); };
    const onDisplay = () => setInstalled(isStandalone());
    window.addEventListener("beforeinstallprompt", onBIP);
    window.addEventListener("appinstalled", onInstalled);
    const mql = window.matchMedia("(display-mode: standalone)");
    mql.addEventListener?.("change", onDisplay);
    // pick up an event captured before this component mounted
    if (window.__gfDeferredPrompt) setDeferred(window.__gfDeferredPrompt);
    return () => {
      window.removeEventListener("beforeinstallprompt", onBIP);
      window.removeEventListener("appinstalled", onInstalled);
      mql.removeEventListener?.("change", onDisplay);
    };
  }, []);

  const promptInstall = async () => {
    if (!deferred) return "unavailable";
    deferred.prompt();
    const { outcome } = await deferred.userChoice;
    window.__gfDeferredPrompt = null;
    setDeferred(null);
    if (outcome === "accepted") setInstalled(true);
    return outcome;
  };

  return { canInstall: !!deferred, installed, ios: isIOS(), android: isAndroid(), promptInstall };
}
